import { Injectable } from '@angular/core';
import { Loader } from '@googlemaps/js-api-loader';
import { environment } from '@my-env/environment';

@Injectable({
  providedIn: 'root'
})
export class GoogleMapsService {
  private loader: Loader;
  private google: any;
  constructor() {
    this.loader = new Loader({
      apiKey: environment.googleApiKey,
      version: 'weekly',
      libraries: ['places']
    });
  }

  load(): Promise<any> {
    return this.loader.load().then(() => {
      this.google = google;
      return google;
    });
  }

  getGoogle() {
    return this.google;
  }
}
